import React from "react";
import AppInfoParser from "app-info-parser";
import {
  Modal,
  Button,
  Form,
  Input,
  Radio,
  message,
  Spin,
  Icon,
  Select,
  Progress,
} from "antd";
import {
  fetchUploadVersion,
  fetchUploadHardwareVersion,
} from "../../../../api/version";
import axios from "axios";
import { upload_token } from "../../../../utils/token";

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};
const { TextArea } = Input;
const { Option } = Select;

// const AppInfoParser = require("app-info-parser");
class AddNewVersion extends React.Component {
  state = {
    noupload: true,
    file: "",
    versionName: "",
    isUpload: false,
    uploadUrl: "",
    showProgress: false,
    percent: 0,
  };
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        if (!this.state.file) {
          this.setState({
            noupload: false,
          });
          return;
        }
        this.setState({
          isUpload: true,
        });
        const { uploadUrl, versionName } = this.state;
        if (this.props.type === "software") {
          const { activation, describe, type } = values;
          fetchUploadVersion({
            key: uploadUrl,
            versionName,
            activation,
            describe,
            type,
          }).then((res) => {
            this.setState({
              isUpload: false,
            });
            if (res.success) {
              this.setState({
                file: "",
                versionName: "",
              });
              message.success("上传成功");
              this.props.handleCancel();
              this.props.getVersionList();
            }
          });
        } else {
          fetchUploadHardwareVersion({
            ...values,
            key: uploadUrl,
            versionName,
          }).then((res) => {
            this.setState({
              isUpload: false,
            });
            if (res.success) {
              this.setState({
                file: "",
                versionName: "",
              });
              message.success("上传成功");
              this.props.handleCancel();
              this.props.getHardwareVersionList();
            }
          });
        }
      }
    });
  };
  onChange = (e) => {
    e.persist();
    this.setState({
      showProgress: true,
    });
    var timeId = setInterval(() => {
      if (this.state.percent < 90) {
        this.setState({
          percent: this.state.percent + 1,
        });
      } else {
        clearInterval(timeId);
      }
    }, 100);
    var formData = new FormData();
    formData.append("file", e.target.files[0]);
    formData.append("token", upload_token());
    formData.append(
      "key",
      this.props.type == "software"
        ? e.target.files[0].name.split(".")[0] + new Date().getTime() + ".apk"
        : e.target.files[0].name.split(".")[0] + new Date().getTime() + ".bin"
    );
    axios.post(`https://upload.qiniup.com/`, formData).then((res) => {
      clearInterval(timeId);
      this.setState(
        {
          file: e.target.files[0],
          uploadUrl: res.data.key,
          showProgress: false,
          percent: 0,
        },
        () => {
          document.getElementById("warningInfo").style.top = 0;
          document.getElementById("warningInfo").style.left = 0;
        }
      );
    });

    //解析版本号

    if (this.props.type == "software") {
      const parser = new AppInfoParser(e.target.files[0]); // or xxx.ipa
      parser
        .parse()
        .then((result) => {
          this.setState({
            versionName: result.versionName,
            noupload: true,
          });
        })
        .catch((err) => {
          console.log("err ----> ", err);
        });
    } else {
      this.setState({
        noupload: true,
      });
    }
  };
  versionNameChange = (e) => {
    this.setState({
      versionName: e.target.value,
    });
  };
  render() {
    const { visible, handleCancel, type, renderPositionOptions } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { file, showProgress, percent } = this.state;

    return (
      <Modal
        width={700}
        destroyOnClose
        title="上传版本"
        visible={visible}
        onOk={this.handleOk}
        onCancel={() => {
          this.setState({
            file: "",
            versionName: "",
            showProgress: false,
            percent: 0,
          });
          handleCancel();
        }}
      >
        <Form
          style={{ width: "70%" }}
          {...formItemLayout}
          onSubmit={this.handleOk}
        >
          <Form.Item label="设备类型">
            {getFieldDecorator("type")(
              <Select placeholder="请选择设备类型" allowClear>
                <Option value="EV200">EV200</Option>
                <Option value="X5">X5</Option>
              </Select>
            )}
          </Form.Item>
          {type == "hardware" ? (
            <Form.Item label="更新位置">
              {getFieldDecorator("position", {
                rules: [
                  {
                    required: true,
                    message: "请输入更新位置",
                  },
                ],
              })(
                <Select placeholder="更新位置" allowClear>
                  {renderPositionOptions()}
                </Select>
              )}
            </Form.Item>
          ) : null}
          <Form.Item
            style={{ marginBottom: 0 }}
            label={
              <React.Fragment>
                <span style={{ color: "red" }}>*</span>{" "}
                {type == "software" ? "安装包" : "文件名称"}
              </React.Fragment>
            }
          >
            {showProgress ? (
              <Progress percent={percent} />
            ) : file ? (
              <React.Fragment>
                <span
                  id="warningInfo"
                  style={{
                    position: "absolute",
                    top: "-22px",
                    left: "115px",
                  }}
                >
                  <Icon type="link" />
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 20,
                      width: 310,
                    }}
                  >
                    {file.name}
                  </span>
                </span>
                <Icon
                  type="close"
                  onClick={() => {
                    this.setState({
                      file: "",
                      versionName: "",
                      uploadUrl: "",
                    });
                  }}
                  style={{
                    position: "absolute",
                    top: 15,
                    left: 335,
                    cursor: "pointer",
                  }}
                />
              </React.Fragment>
            ) : (
              <a className="a-upload">
                <input
                  type="file"
                  accept={type == "software" ? ".apk" : ".bin"}
                  onChange={($event) => this.onChange($event)}
                ></input>
                {type == "software" ? "请选择安装包" : "请选择文件"}
              </a>
            )}

            {this.state.noupload ? null : (
              <span
                style={{
                  width: 100,
                  position: "absolute",
                  top: "-22px",
                  left: "115px",
                  color: "red",
                }}
              >
                请上传安装包
              </span>
            )}
          </Form.Item>
          <Form.Item
            label={
              <React.Fragment>
                <span style={{ color: "red" }}>*</span> 版本号
              </React.Fragment>
            }
          >
            <Input
              disabled={type == "software"}
              value={this.state.versionName}
              onChange={this.versionNameChange}
            ></Input>
          </Form.Item>
          <Form.Item label="更新内容">
            {getFieldDecorator("describe", {
              rules: [
                {
                  required: true,
                  message: "请输入更新内容",
                },
              ],
            })(<TextArea rows={3} placeholder="请输入更新内容" />)}
          </Form.Item>
          <Form.Item label="是否启用">
            {getFieldDecorator("activation", {
              initialValue: false,
              rules: [
                {
                  required: true,
                  message: "请选择状态",
                },
              ],
            })(
              <Radio.Group>
                <Radio value={true}>是</Radio>
                <Radio value={false}>否</Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Form>
        {this.state.isUpload ? (
          <Spin
            size="large"
            tip="上传中..."
            style={{ position: "absolute", top: "48%", left: "48%" }}
          />
        ) : null}
        {/* <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.3)"
          }}
        ></div> */}
      </Modal>
    );
  }
}
export default Form.create()(AddNewVersion);
